import { render, staticRenderFns } from "./extendedSettings.vue?vue&type=template&id=9771c11e"
import script from "./extendedSettings.vue?vue&type=script&lang=js"
export * from "./extendedSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports